/*
 * App Selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectApp = (state) => state.app || initialState;

const makeSelectSession = () =>
  createSelector(selectApp, (appState) => appState.session);

const makeSelectSessionLoading = () =>
  createSelector(selectApp, (appState) => appState.sessionLoading);

const makeSelectSessionError = () =>
  createSelector(selectApp, (appState) => appState.sessionError);

const makeSelectBOMData = () =>
  createSelector(selectApp, (appState) => appState.bomData);

const makeSelectCSVData = () =>
  createSelector(selectApp, (appState) => appState.csvData);

const makeSelectLoading = () =>
  createSelector(selectApp, (appState) => appState.loading);

const makeSelectSubmitting = () =>
  createSelector(selectApp, (appState) => appState.submitting);

const makeSelectError = () =>
  createSelector(selectApp, (appState) => appState.error);

const makeSelectSuccess = () =>
  createSelector(selectApp, (appState) => appState.success);

export {
  selectApp,
  makeSelectSession,
  makeSelectSessionLoading,
  makeSelectSessionError,
  makeSelectBOMData,
  makeSelectCSVData,
  makeSelectLoading,
  makeSelectSubmitting,
  makeSelectError,
  makeSelectSuccess,
};
